import {http} from './http/request';

const ABSOLUTE_AVATAR_RE = /^(data:|blob:|https?:)/;

const getUserDisplayName = user => {
    if (!user) return '';
    return user.nickname || user.name || '';
};

const getUserLoginName = user => {
    if (!user) return '';
    return user.account || '';
};

const getUserId = user => {
    if (!user) return '';
    return user.id || '';
};

const getUserAvatarUrl = user => {
    const avatar = user && user.avatar;
    if (!avatar) return null;
    if (ABSOLUTE_AVATAR_RE.test(avatar)) return avatar;
    return `${http.domain}${avatar}`;
};

const userHasRole = (user, roleName) => (
    Boolean(user && Array.isArray(user.roles) && user.roles.includes(roleName))
);
const userHasPermission = (user, permission) => (
    Boolean(user && Array.isArray(user.permissions) && user.permissions.includes(permission))
);

export {
    getUserAvatarUrl,
    getUserDisplayName,
    getUserId,
    getUserLoginName,
    userHasRole,
    userHasPermission
};
